import React from 'react'
import { connect } from 'react-redux'
import { SelectWrapper } from '../components/shared/select/SelectWrap'
import styles from "./BrokerSelector.scss"
import { getBrokerInfo } from 'state/actions'

@connect(state => {
	const hasInternalAccess = state.app.userTypeId === '1' || state.app.userTypeId === '3' ? true : false

	return {
		hasInternalAccess
	}
})

class BrokerSelector extends React.Component {
	static propTypes = {
		dispatch: React.PropTypes.func.isRequired,
		setBrNr: React.PropTypes.func.isRequired,
		brokers: React.PropTypes.object.isRequired,
		brNr: React.PropTypes.string.isRequired,
		customClass: React.PropTypes.string,
		disabled: React.PropTypes.bool,
		hasInternalAccess: React.PropTypes.bool,
	}

	constructor(props) {
		super(props)
		this.state = {
			brokerInputVal: props.brNr
		}
	}
	updateBroker(brNr) {
		const { dispatch, setBrNr } = this.props
		dispatch(setBrNr(brNr))
	}

	getIcon() {
		return require('resources/images/person_search_green.svg')
	}

	renderSelector() {
		const { brNr, brokers, disabled } = this.props
		const brokerIds = Object.keys(brokers)
		const options = brokerIds.map(id => ({
			label: id,
			value: id,
		}))
		return (
			brokerIds.length > 1 ? (
				<SelectWrapper
					value={brNr}
					options={options}
					isDisabled={disabled}
					onChange={item => this.updateBroker(item.value)}
					className={styles.brokerSelector}
				/>
			) : (
				<span>{brNr}</span>
			)
		)
	}

	searchForBroker = async () => {
		const { brokerInputVal } = this.state
		const { dispatch } = this.props

		// if (brokerInputVal && brokerInputVal.length > 3) {
		const brokerInfoRes = await dispatch(getBrokerInfo(brokerInputVal))
		// }
	}

	renderBrokerSearch() {
		//require oracle procedure to continue
		const { brokerInputVal } = this.state

		return (
			<div onSubmit={(ev) => {
				ev.preventDefault()
				return this.searchForBroker()
			}} className={styles.brokerSearch}>
				<input type="text" value={brokerInputVal} onChange={(ev => {
					ev.preventDefault()
					this.setState({ brokerInputVal: ev.target.value })
				})} />
				<img src={this.getIcon()} onClick={this.searchForBroker} />
			</div>
		)
	}

	render() {
		const { customClass, hasInternalAccess } = this.props
		return (
			<span className={`${customClass}`}>
				{hasInternalAccess ?
					this.renderBrokerSearch() : this.renderSelector()
				}
			</span>
		)
	}
}

export default BrokerSelector



// WEBPACK FOOTER //
// ./components/BrokerSelector.jsx